module.exports = __webpack_public_path__ + "img/google-forms.fea8867f.png";